module.exports = __webpack_public_path__ + "static/media/heart.f9cfb75a.svg";